import {Box, Typography} from "@mui/material";

const PageNotFound = () =>
    <Box style={{backgroundColor: "gray"}}>
        <Typography style={{backgroundColor: "gray"}} variant={"h4"}>Page not found !</Typography>
    </Box>;
export default PageNotFound;
